import {Module} from 'vuex';
import {AlertNotificationActions, ClubLocationsActions, EmployeeProfileActions, MemberSearchActions, ProfileActions, UrlActions} from './actions';
import {AlertNotificationGetters, ClubLocationsGetters, EmployeeProfileGetters, MemberSearchGetters, ProfileGetters, UrlGetters} from './getters';
import {AlertNotificationMutations, ClubLocationsMutations, EmployeeProfileMutations, MemberSearchMutations, ProfileMutations, UrlMutations} from './mutations';
import {AlertNotificationState, ClubLocationsState, EmployeeProfileState, MemberSearchState, ProfileState, UrlState} from './states';
import EcCommon from '../../../types/ec/ecCommon';
import EcMemberSearch from '../../../types/ec/ecMemberSearch';
import LtFramework from '../../../types/lt/ltFramework';

export const AlertNotificationModule: Module<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
	namespaced: true,
	state: AlertNotificationState,
	getters: AlertNotificationGetters,
	actions: AlertNotificationActions,
	mutations: AlertNotificationMutations,
};

export const ClubLocationsModule: Module<EcCommon.IClubLocationsState, LtFramework.IRootState> = {
	namespaced: true,
	state: ClubLocationsState,
	getters: ClubLocationsGetters,
	actions: ClubLocationsActions,
	mutations: ClubLocationsMutations,
};

export const EmployeeProfileModule: Module<LtFramework.IEmployeeProfileState, LtFramework.IRootState> = {
	namespaced: true,
	state: EmployeeProfileState,
	getters: EmployeeProfileGetters,
	actions: EmployeeProfileActions,
	mutations: EmployeeProfileMutations,
};

export const MemberSearchModule: Module<EcMemberSearch.IState, LtFramework.IRootState> = {
	namespaced: true,
	state: MemberSearchState,
	getters: MemberSearchGetters,
	actions: MemberSearchActions,
	mutations: MemberSearchMutations,
};

export const ProfileModule: Module<LtFramework.IProfileState, LtFramework.IRootState> = {
	namespaced: true,
	state: ProfileState,
	getters: ProfileGetters,
	actions: ProfileActions,
	mutations: ProfileMutations,
};

export const UrlModule: Module<LtFramework.IUrlState, LtFramework.IRootState> = {
	namespaced: true,
	state: UrlState,
	getters: UrlGetters,
	actions: UrlActions,
	mutations: UrlMutations,
};
